import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
} from 'mailup-web-components'
import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard/useRouteLeaveGuard'
import useWindowLeaveGuard from 'Hooks/useWindowLeaveGuard/useWindowLeaveGuard'

const ModalConfirmLeave = ({ isDirty, title, message }) => {
  const intl = useIntl()
  const [prompt, allow, deny] = useRouteLeaveGuard(!isDirty)
  useWindowLeaveGuard(!isDirty)

  const handleConfirm = () => {
    allow()
  }

  return (
    <Modal
      data-mu-test="modal-confirm-leave"
      show={prompt}
      onClose={deny}
      showClose
      closeOnOverlayClick
      size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage({
          id: title,
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: message,
          })}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button kind="neutral" onClick={deny} data-mu-test="button-cancel">
          {intl.formatMessage({ id: 'Load.MessageOverview.Cancel' })}
        </Button>
        <Button
          kind="danger"
          onClick={handleConfirm}
          data-mu-test="button-confirm"
        >
          {intl.formatMessage({ id: 'Load.MessageOverview.Exit' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalConfirmLeave.defaultProps = {
  isDirty: false,
  title: 'Load.MessageOverview.ConfirmExitTitle',
  message: 'Load.MessageOverview.ConfirmExitDescription',
}

ModalConfirmLeave.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
}

export default ModalConfirmLeave
